import React from "react";
import { FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa";
import { LuMail } from "react-icons/lu";
import "../styles/Footer.scss"; // we’ll extract just footer styles here
import { useLanguage } from "../context/LanguageContext";
import { useConsent } from "../consent/ConsentContext";

const Footer = ({ theme = "day" }) => {
  const { t } = useLanguage();
  const { openPreferences } = useConsent();
  const footerClass = theme === "night" ? "footer--night" : "";
  const separatorClass =
    theme === "night" ? "footer-separator footer-separator--night" : "footer-separator";

  return (
    <>
      <div className={separatorClass}></div>
      <footer className={`footer ${footerClass}`.trim()}>
        <div className="footer-top">
          {/* Left column */}
          <div className="footer-heading">
            <h2>
              {t("footer.heading.line1", "Let’s")}{" "}
              <strong>{t("footer.heading.highlight", "Paddle")}</strong>
              <br /> {t("footer.heading.line2", "Together")}
            </h2>
            <p>
              {t(
                "footer.paragraph",
                "Wayli SUP & Kayak Rentals – We make water adventures easy, safe, and seriously fun. Stable boards, fresh gear, and a crew that loves the water as much as you will. Whether it’s your first time or your hundredth paddle, we’ve got routes, tips, and good vibes waiting."
              )}
            </p>
          </div>

          {/* Right column */}
          <div className="footer-bottom">
            <div className="footer-brand">
              <h3>Wayli</h3>
              <div className="footer-socials">
                <div className="footer-icons">
                  <a href="https://www.instagram.com/wayli.eu"> <FaInstagram /> </a>
                </div>
                <div className="footer-icons" href="#">
                  <a href="https://www.tiktok.com/@wayli.eu?_r=1"> <FaTiktok /> </a>
                </div>
                <div className="footer-icons">
                  <a href="mailto:wayli@wayli.eu"> <LuMail /> </a>
                </div>
                <div className="footer-icons">
                  <a
                    href="https://wa.me/4368181542983"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="WhatsApp"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>

            <div className="footer-links">
              <div className="footer-column">
                <a href="/policies">{t("footer.links.privacy", "Legal Information")}</a>
                <button type="button" onClick={openPreferences}>
                  {t("footer.links.cookies", "Cookie settings")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
